import { Button } from "@common/index";
import styles from "./styles.module.scss";

export const BreakdownWithImage = ({ onContinue, img, title, paragraph }) => {
  return (
    <div className={styles.container} id="breakdown">
      <div className={styles.content}>
        <div className={styles.img}>
          <img src={img} alt="finger" />
        </div>
        <h5>{title}</h5>
        {paragraph.map((item, index) => (
          <p dangerouslySetInnerHTML={{ __html: item }} key={index}></p>
        ))}
      </div>
      <div className={styles.action}>
        <Button onClick={onContinue}>Continue</Button>
      </div>
    </div>
  );
};
